import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import SelectBox from 'src/components/SelectBox';
import Button from 'src/components/Button';
import { useGetSurveyResponsesByDatasheet } from 'src/hooks/survey';
import TextField from 'src/components/TextField';
import Loader from 'src/components/Loader';
import s from './JubSurveyResults.styles';
import QuestionResponseSection from './QuestionResponseSection';

const JobSurveyResults = props => {

  const { jobId, datasheet } = props;
  const [selectedResponseIndex, setSelectedResponseIndex] = useState(0);
  const { t } = useTranslation();
  const { data, loading } = useGetSurveyResponsesByDatasheet({
    jobId,
    datasheetVersionId: datasheet.currentVersion.id,
  });

  const responseSelectionList = useMemo(() => {
    if (data && data.surveyResponses?.length) {

      const { surveyResponses } = data;

      const formatString = 'DD-MMM-YYYY HH:mm:ss z';
      const surveyResponsesWithDatesInUTC = surveyResponses.map(response => ({
        ...response,
        lastActivityAtUTC: response.lastActivityAt ? moment.utc(response.lastActivityAt).format(formatString) : '',
        startedAtUTC: response.startedAt ? moment.utc(response.startedAt).format(formatString) : '',
        finishedAtUTC: response.finishedAt ? moment.utc(response.finishedAt).format(formatString) : '',
      }));

      return surveyResponsesWithDatesInUTC
        .map((response, index) => {
          return {
            label: `#${response.responseNumber}: ${response.lastActivityAtUTC}`,
            value: response,
          };
        })
        .map((response, index) => {
          const temp = { ...response };
          temp.value.indexValue = index;
          return temp;
        });
    }
    return [];
  }, [loading]);

  return (
    <s.Container>
      {loading ? (
        <Loader />
      ) : (
        <>
          <s.ResultSelectionSection>
            <Button onClick={() => {
              if (responseSelectionList.length === 0 || selectedResponseIndex === 0) {
                return;
              }
              setSelectedResponseIndex(selectedResponseIndex - 1);
            }} type="button">{t('PREVIOUS')}</Button>
            <SelectBox
              onChange={(v) => setSelectedResponseIndex(v.value.indexValue)}
              options={responseSelectionList}
              value={responseSelectionList[selectedResponseIndex]} />
            <Button onClick={() => {
              if (responseSelectionList.length === 0 || selectedResponseIndex === responseSelectionList.length - 1) {
                return;
              }
              setSelectedResponseIndex(selectedResponseIndex + 1);
            }} type="button">{t('NEXT')}</Button>
          </s.ResultSelectionSection>

          {t('RESPONSE_FINGERPRINT')}
          <s.ResponseFingerprintSection>
            <div>
              <TextField
                disabled={true}
                label={t('RESPONSE_NO')}
                value={responseSelectionList[selectedResponseIndex]?.value.responseNumber}
              />
            </div>
            <div className={s.responderTimezone}>
              <TextField
                disabled={true}
                label={t('RESPONDER_TIMEZONE')}
                value={responseSelectionList[selectedResponseIndex]?.value.timezone}
              />
            </div>
            <div className={s.surveyStartedAt}>
              <TextField
                disabled={true}
                label={t('SURVEY_STARTED_AT')}
                value={responseSelectionList[selectedResponseIndex]?.value.startedAtUTC}
              />
            </div>
            <div className={s.lastActivity}>
              <TextField
                disabled={true}
                label={t('LAST_ACTIVITY_AT')}
                value={responseSelectionList[selectedResponseIndex]?.value.lastActivityAtUTC}
              />
            </div>
            <div className={s.responderOs}>
              <TextField
                disabled={true}
                label={t('RESPONDER_OS')}
                value={responseSelectionList[selectedResponseIndex]?.value.responderOs}
              />
            </div>
            <div className={s.browser}>
              <TextField
                disabled={true}
                label={t('BROWSER')}
                value={responseSelectionList[selectedResponseIndex]?.value.browser}
              />
            </div>
            <div className={s.surveyFinishedAt}>
              <TextField
                disabled={true}
                label={t('SURVEY_FINISHED_AT')}
                value={responseSelectionList[selectedResponseIndex]?.value.finishedAtUTC}
              />
            </div>
          </s.ResponseFingerprintSection>

          <s.QuestionResponseSection>
            <QuestionResponseSection
              datasheet={datasheet}
              results={responseSelectionList[selectedResponseIndex]?.value.results}
            />
          </s.QuestionResponseSection>
        </>
      )}
    </s.Container>
  );
};

export default React.memo(JobSurveyResults);
